import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {AppBarModule} from "@app/presentation/components/app-bar/app-bar.module";
import {ButtonModule} from "@app/presentation/components/button/button.module";
import {DeliveryPointsModule} from "@app/presentation/components/delivery-points/delivery-points.module";
import {LoadingSpinnerModule} from "@app/presentation/components/loading-spinner/loading-spinner.module";
import {
  SelectDeliveryPointRoutingModule
} from "@app/presentation/pages/select-delivery-point/select-delivery-point-routing.module";
import {DialogsModule} from "@app2u/dialogs";
import {TranslateModule} from "@ngx-translate/core";
import {AngularSvgIconModule} from "angular-svg-icon";
import {SelectDeliveryPointComponent} from './select-delivery-point.component';


@NgModule({
  declarations: [
    SelectDeliveryPointComponent
  ],
  imports: [
    CommonModule,
    SelectDeliveryPointRoutingModule,
    TranslateModule,
    ButtonModule,
    AppBarModule,
    LoadingSpinnerModule,
    DialogsModule,
    AngularSvgIconModule,
    DeliveryPointsModule
  ]
})
export class SelectDeliveryPointModule { }
